import Vue from 'vue'
import Router from 'vue-router'
import store from '@store/index'
import commonRoutes from './common-routes'
import authRoutes from './auth-routes'
import adminRoutes from './admin-routes'
import agencyRoutes from './agency-routes'
import userRoutes from './user-routes'
import lazyLoading from './lazyLoading'

Vue.use(Router)

const createRouter = () => {
  const routes = [
    ...commonRoutes,
    ...authRoutes,
    ...adminRoutes,
    ...agencyRoutes,
    ...userRoutes,
    { path: '*', component: lazyLoading('Pages/NotFound') }
  ]
  const router = new Router({
    mode: 'history',
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
      if (to.hash) return { selector: to.hash }
      else if (savedPosition) return savedPosition
      else return { x: 0, y: 0 }
    }
  })
  return router
}

const router = createRouter()
Router.prototype.resetRouter = function() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

const commonRouteNames = commonRoutes.map(item => item.name)
router.beforeEach((to, from, next) => {
  if (store.getters['auth/isLoggedIn'] && !store.state.auth.user) {
    if (commonRouteNames.includes(to.name)) next()
    else store.dispatch('auth/getProfile', true).then(() => next()).catch(() => next())
  } else next()
})

export default router